/*
 * Contenido editorial de las secciones (fotos del hero, beneficios, posts de redes, etc.).
 * Se edita aquí sin tocar los componentes. Rutas relativas a /public.
 */

/**
 * @typedef {Object} SlideHero
 * @property {string} url  foto original (el fondo desenfocado usa su miniatura)
 * @property {string} cap  pie con el lugar
 */

/** Fotos del carrusel del hero, en orden. @type {SlideHero[]} */
export const heroSlides = [
  { url: 'images/chamonix/chamonix6.webp', cap: 'Aiguille du Dru · Chamonix, Francia' },
  { url: 'images/brujas/brujas9.webp', cap: 'Canales de Brujas · Bélgica' },
  { url: 'images/disney-world-orlando/disney-world3.webp', cap: 'Magic Kingdom · Walt Disney World' },
  { url: 'images/paris/paris10.webp', cap: 'Ópera Garnier · París' },
  { url: 'images/glacier-3000/glacier-3000-4.webp', cap: 'Peak Walk · Glacier 3000, Suiza' },
  { url: 'images/puerto-vallarta/puerto-vallarta1.webp', cap: 'Atardecer en el malecón · Puerto Vallarta' }
];

/** Milisegundos que dura cada foto del hero. @type {number} */
export const HERO_DURACION = 6500;

/** Avatares de la prueba social del hero (fotos de images/resenas/<nombre>.webp, en versión micro). @type {string[]} */
export const heroAvatares = ['familia-sanchez', 'familia-chavarria', 'familia-rosales', 'familia-magallanes', 'vanessa-rebolledo'];

/**
 * @typedef {Object} Beneficio
 * @property {string} icon  clases de Font Awesome
 * @property {string} t     título
 * @property {string} d     descripción
 */

/** "Reservar conmigo incluye" (sale de la pregunta frecuente #3). @type {Beneficio[]} */
export const beneficios = [
  { icon: 'fa-solid fa-piggy-bank', t: 'Reservación accesible', d: 'Aparta tu paquete con un depósito inicial y paga el resto poco a poco, sin liquidar todo de una vez.' },
  { icon: 'fa-solid fa-tags', t: 'Promociones aplicadas', d: 'Si después de reservar aparece una promoción, la aplico para que aproveches el mejor precio posible.' },
  { icon: 'fa-solid fa-headset', t: 'Asesoría personalizada', d: 'Te acompaño antes y durante tu viaje para resolver cualquier duda o situación que se presente.' },
  { icon: 'fa-solid fa-lightbulb', t: 'Tips y recomendaciones', d: 'Te comparto consejos útiles para que disfrutes al máximo cada parque y cada destino.' },
  { icon: 'fa-solid fa-mobile-screen-button', t: 'App de Disney lista', d: 'Te enseño a usar la app oficial, enlazo tus boletos a tu cuenta y la dejo configurada.' },
  { icon: 'fa-solid fa-utensils', t: 'Reservas en restaurantes', d: 'Te ayudo a reservar en los restaurantes de Disney para que no te preocupes por nada.' }
];

/**
 * @typedef {Object} PostRedes
 * @property {string} foto   foto original dentro de images/ (la tarjeta usa su versión mini)
 * @property {string} lugar
 * @property {'ig'|'tt'} red  Instagram o TikTok (a qué perfil enlaza)
 */

/**
 * Tarjetas de "Lo que vivo, lo cuento en redes". Son fotos propias que enlazan al perfil;
 * para contenido real, reemplazar por los embeds oficiales de Instagram/TikTok.
 * @type {PostRedes[]}
 */
export const postsRedes = [
  { foto: 'chamonix/chamonix2.webp', lugar: 'Chamonix', red: 'ig' },
  { foto: 'paris/paris5.webp', lugar: 'París', red: 'tt' },
  { foto: 'disney-world-orlando/disney-world6.webp', lugar: 'Epcot', red: 'ig' },
  { foto: 'brujas/brujas1.webp', lugar: 'Brujas', red: 'tt' },
  { foto: 'universal-hollywood/universal-hollywood1.webp', lugar: 'Super Nintendo World', red: 'ig' },
  { foto: 'glacier-3000/glacier-3000-2.webp', lugar: 'Glacier 3000', red: 'tt' },
  { foto: 'sea-world-orlando/sea-world5.webp', lugar: 'SeaWorld Orlando', red: 'ig' },
  { foto: 'puerto-vallarta/puerto-vallarta6.webp', lugar: 'Puerto Vallarta', red: 'tt' }
];

/**
 * @typedef {Object} FotoCollage
 * @property {string} src  foto original (se muestra en versión mini)
 * @property {string} cap
 * @property {'a'|'b'|'c'} pos  posición dentro del collage (clase tours-collage__<pos>)
 */

/** Collage de polaroids de "Experiencias Disney". @type {FotoCollage[]} */
export const collageDisney = [
  { src: 'images/disney-world-orlando/disney-world3.webp', cap: 'Magic Kingdom', pos: 'a' },
  { src: 'images/disneyland-paris/disneyland-paris7.webp', cap: 'Disneyland Paris', pos: 'b' },
  { src: 'images/disneyland-california/disney12.webp', cap: 'Disneyland California', pos: 'c' }
];

/** Lo que incluye la página oficial de Disney. @type {string[]} */
export const checksDisney = [
  'Información detallada de los destinos Disney',
  'Paquetes disponibles y promociones',
  'Consejos y tips para aprovechar al máximo tu experiencia',
  'Todo lo necesario para empezar a soñar con tu próxima aventura'
];

/** Chips de "¿Qué viaje sueñas?" en Contacto. @type {string[]} */
export const tiposViaje = ['Disney', 'Universal', 'Europa', 'Crucero', 'México', 'Otro destino'];
